"use client";

import {createContext, ReactNode, useEffect, useState} from "react";


export type CookieContext = typeof Cookiebot.consent

const defaultState: typeof Cookiebot.consent = {
    marketing: false,
    statistics: false,
    preferences: false,
    necessary: true,
    stamp: ""
};

const acceptAllState: typeof Cookiebot.consent = {
    marketing: true,
    statistics: true,
    preferences: true,
    necessary: true,
    stamp: ""
};

export const ctx = createContext<CookieContext>(defaultState);

type CookieContextProviderProps = {
    children: ReactNode;
    isCookieScan?: boolean;
}

export function CookieContextProvider({children}: CookieContextProviderProps) {
    const [state, setState] = useState<typeof Cookiebot.consent>(defaultState);

    useEffect(() => {
        if ( window.navigator?.userAgent?.includes("Cookiebot") ) {
            setState(acceptAllState);
            return;
        }

        setState({
            ...Cookiebot.consent
        })

        window.addEventListener('CookiebotOnAccept', onUpdate);
        window.addEventListener('CookiebotOnDecline', onUpdate);
        window.addEventListener('CookiebotOnConsentReady', onUpdate);
        window.addEventListener('CookiebotOnLoad', onUpdate);

        function onUpdate() {
            setState({
                ...Cookiebot.consent
            });
        }
    }, []);

    return (
            <ctx.Provider value={state}>{children}</ctx.Provider>
    );
}